module.exports = __webpack_public_path__ + "img/sort.48e4b51d.svg";